import { SIGNOUT_USER_SUCCESS } from '../User/UserTypes';
import * as TYPES from './CategoriesTypes';

const initialState = {
  list: null,
  category: null,
};

export default function categoryReducer(state = initialState, action) {
  const { type, payload } = action;
  if (type === TYPES.CATEGORY_LIST_SUCCESS) {
    return {
      ...state,
      list: payload,
    };
  } else if (type === SIGNOUT_USER_SUCCESS) {
    return initialState;
  }
  return state;
}
